import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  FormControlLabel,
  Switch,
} from "@mui/material";
import Grid from "@mui/material/Grid2";

import SuiButton from "components/SuiButton";
import SuiInput from "components/SuiInput";
import SuiTypography from "components/SuiTypography";

import DatosBasicosApi from "api/datosbasicosApi";
import { obtenerMensajeError } from "utils/apiErrors";

const FORM_INICIAL = {
  url: "",
  id_reunion: "",
  estado: true,
};

const EditSalaZoomModal = ({ open, onClose, sala, onSuccess }) => {
  const [error, setError] = useState(undefined);
  const [saving, setSaving] = useState(false);
  const [formData, setFormData] = useState(FORM_INICIAL);

  useEffect(() => {
    if (sala) {
      setFormData({
        url: sala.url,
        id_reunion: sala.id_reunion,
        estado: sala.estado,
      });
    } else {
      setFormData(FORM_INICIAL);
    }
    setError(undefined);
  }, [sala, open]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.url.trim().toLowerCase().startsWith("https://")) {
      setError("Debes registrar un Enlace válido que inicie con https://");
      return;
    }
    if (!/^[0-9]+$/.test(formData.id_reunion.replace(/\s/g, ""))) {
      setError("Debes registrar el ID de la Reunión (solo números).");
      return;
    }
    if (sala) {
      const confirmacion = window.confirm(
        `¿Está seguro(a) de actualizar la sala ${sala.nombre}? Las audiencias ya programadas conservan el enlace con el que fueron creadas.`
      );
      if (!confirmacion) return;
    }
    try {
      setSaving(true);
      if (sala) {
        await DatosBasicosApi.updateSalaZoom(sala.codigo, formData);
      } else {
        await DatosBasicosApi.createSalaZoom(formData);
      }
      onSuccess();
    } catch (error) {
      console.error("Error al guardar la sala Zoom:", error);
      setError(obtenerMensajeError(error, "Error al guardar la Sala Zoom."));
    } finally {
      setSaving(false);
    }
  };

  const hCClose = () => {
    setError(undefined);
    onClose();
  };

  return (
    <Dialog open={open} onClose={hCClose} maxWidth="md" fullWidth>
      <DialogTitle>{sala ? `Editar Sala ${sala.nombre}` : "Nueva Sala Zoom"}</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={12}>
              <SuiTypography variant="h6" fontWeight="light">
                Enlace de la Reunión
              </SuiTypography>
              <SuiInput
                name="url"
                value={formData.url}
                onChange={handleChange}
                placeholder="https://us02web.zoom.us/j/..."
                inputProps={{ maxLength: 200 }}
                fullWidth
              />
            </Grid>
            <Grid size={6}>
              <SuiTypography variant="h6" fontWeight="light">
                ID de la Reunión
              </SuiTypography>
              <SuiInput
                name="id_reunion"
                value={formData.id_reunion}
                onChange={handleChange}
                placeholder="Ej: 6386546411"
                inputProps={{ maxLength: 20 }}
                fullWidth
              />
            </Grid>
            <Grid size={6}>
              <SuiTypography variant="h6" fontWeight="light">
                Estado
              </SuiTypography>
              <FormControlLabel
                control={
                  <Switch
                    checked={formData.estado}
                    onChange={(e) => setFormData((prev) => ({ ...prev, estado: e.target.checked }))}
                  />
                }
                label={formData.estado ? "Activa (disponible al programar)" : "Inactiva"}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <SuiButton onClick={hCClose} buttonColor="light">
            Cancelar
          </SuiButton>
          <SuiButton type="submit" variant="gradient" buttonColor="dark" disabled={saving}>
            {saving ? "Guardando..." : sala ? "Actualizar" : "Crear"}
          </SuiButton>
        </DialogActions>
      </form>
    </Dialog>
  );
};

EditSalaZoomModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  sala: PropTypes.object,
  onSuccess: PropTypes.func.isRequired,
};

export default EditSalaZoomModal;
